import(/* webpackMode: "eager" */ "/home/runner/actions-runner/_work/cocreation-front/cocreation-front/app/[locale]/not-found.tsx");
